import React, { useContext, useEffect } from "react";
import { useState } from "react";
import { Alert, Form, Table } from "react-bootstrap";
import PortalService from '../../../services/portal.service';
import StateContext from "../../../context/State";
import { useAppSelector } from "../../../../../redux/hooks";
import { ClientConnectCustomFieldSet } from "../../../../Settings/ClientConnectFirmSettings/CustomFieldSets/types";
import { lddGlobalSessionInfo } from "../../../../navigationTypes";
import { getCustomDocumentSet } from "../../../../Settings/ClientConnectFirmSettings/CustomDocumentSets/customDocumentSetFuncs";
import { RPWDataReader, getDataReader } from "../../../../../livedataFuncs";
import { lddStateObject } from "../../../../../redux/reducer";
import DocumentRequestComponent from "../../../components/DocumentRequestComponent";
import { NewCustomDocumentSetModal } from "../../../../Settings/ClientConnectFirmSettings/CustomDocumentSets/newCustomDocumentSet";


export type AddDocumentRequestsProps = {
    setCustomFieldSetNames: (arg0: string[]) => void;
    setDocumentRequests: any;
    customFieldSetNames: string[];
    addRow?: boolean;
    setAddRow?: (arg0: boolean) => void;
    afterInit: boolean;
}

export type CheckedSetArray = {
    name: string;
    checked: boolean;
}

const AddCustomDocuments = (props: AddDocumentRequestsProps) => {
    const { state } = useContext(StateContext);
    const portalService = new PortalService(state);
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const [show, setShow] = useState<boolean>(false)
    const [customFieldSets, setCustomFieldSets] = useState<ClientConnectCustomFieldSet[]>([])
    const [editFieldSet, setEditFieldSet] = useState<ClientConnectCustomFieldSet>(null);
    const [selectedCustomFieldSets, setSelectedCustomFieldSets] = useState<string[]>([])
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
    const [clientInfo, setClientInfo] = useState([]);

    useEffect(() => { getClientInfo(); }, [])
    useEffect(() => {
        const getSetCustomDocumentSet = async () => {
            const response = await getCustomDocumentSet(sessionInfo.sid);
            if (response && response.length !== 0) {
                const processedFieldSets = response.map(fieldSet => {
                    const processedFields = fieldSet.fields.map((field) => {
                        if (field.perClient) {
                            let identifierObj = field.identifier ? JSON.parse(field.identifier) : {};
                            clientInfo.forEach((clientName) => {
                                if (!identifierObj.hasOwnProperty(clientName)) {
                                    identifierObj[clientName] = "";
                                }
                            });
                            return {
                                ...field,
                                identifier: JSON.stringify(identifierObj)
                            };
                        } else {
                            return {...field};
                        }
                    });
                    return {
                        ...fieldSet,
                        fields: processedFields
                    };
                });
                setCustomFieldSets(processedFieldSets);
            }
        };
        getSetCustomDocumentSet();
    }, [clientInfo]);

    const getClientInfo = async () => {
        const province = await portalService.getProvince();
        const names = DataReaderObj.getUserNames(province);
        setClientInfo(names);
    }

    const handleClose = () => {
        setEditFieldSet(null)
        setShow(false);
    }

    const handleShow = async () => {
        setShow(true);
    };

    const handleFieldSetSelected = (index, e) => {
        if (e.target.checked) {
            props.setCustomFieldSetNames([...props.customFieldSetNames, customFieldSets[index].fieldSetName])
            setSelectedCustomFieldSets([...selectedCustomFieldSets, customFieldSets[index].fieldSetName])
        } else {
            for (let i = 0; i < selectedCustomFieldSets.length; i++) {
                if (selectedCustomFieldSets.includes(customFieldSets[index].fieldSetName)) {
                    const prevSelectedCustomFieldSets = [...selectedCustomFieldSets];
                    prevSelectedCustomFieldSets.splice(i, 1);
                    setSelectedCustomFieldSets(prevSelectedCustomFieldSets)
                }
            }
            const prevCustomFieldSetNames = [...props.customFieldSetNames];
            for (let i = 0; i < prevCustomFieldSetNames.length; i++) {
                if (prevCustomFieldSetNames[i] === customFieldSets[index].fieldSetName) {
                    prevCustomFieldSetNames.splice(i, 1)
                }
            }
            props.setCustomFieldSetNames(prevCustomFieldSetNames)
        }
    }

    return (
        <>
            {!props.afterInit &&
                <>
                    <h3>Include Document Requests Templates</h3>
                    <Table hover bordered striped>
                        <thead>
                            <tr>
                                <th>
                                    Document Requests Template Name
                                </th>
                                <th>
                                    Include
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {customFieldSets.map((customFieldSet, index) => {
                                return (
                                    <tr key={'custom-field-row-' + index}>
                                        <td
                                            onClick={() => {
                                                setEditFieldSet(customFieldSet)
                                                handleShow()
                                            }}
                                        >
                                            {customFieldSet.fieldSetName}
                                        </td>
                                        <td>
                                            <Form.Check
                                                type='checkbox'
                                                onChange={(e) => handleFieldSetSelected(index, e)}
                                                checked={selectedCustomFieldSets.includes(customFieldSet.fieldSetName)}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </>
            }
            <br />
            <NewCustomDocumentSetModal
                show={show}
                onHide={handleClose}
                editFieldSet={editFieldSet}
                fromSettings={false}
            />

            <h3>Request Documents from Clients</h3>
            <Alert variant="info">
                Enter the names of the documents you would like your client(s) to submit.
            </Alert>
            <DocumentRequestComponent
                setDocumentRequests={props.setDocumentRequests}
            />
        </>
    )
}

export default AddCustomDocuments;
